<template>
    <dialog-v2
      :show="show"
      :saveButton="false"
      title="Historial de cambios"
      height="fit-content"
      @close="$emit('close')">
      <template slot="content">
        <v-layout row wrap>
          <v-flex v-if="!haveData" md12 class="d-flex justify-center align-center">
            <v-layout row justify-center align-center class="no-info">
              <span>Sin Información</span>
            </v-layout>
          </v-flex>
          <v-flex v-else md12>
            <v-layout column>
              <vue-perfect-scrollbar v-if="logs.length" class="scrollbar">
                <v-flex
                v-for="(log, i) in logs"
                :key="`log-${i}`"
                class="log-entry d-flex align-center justify-start pa-2"
                :class="{'even-log': i % 2 === 0, 'non-log': i % 2 !== 0}"
              >
              <v-flex md1 class="mr-2">
                <avatar
                  :initials="log.user.first_name[0]"
                  :size="35"
                  background-color="#EDEEF2"
                  color="#919191"
                  class="px-2 mt-2 py-0 custom-avatar"
                />
              </v-flex>
              <v-flex md-11 class="mt-2">
                <v-flex md-12>
                  <span class="text-bold">{{ `${log.user.first_name} ${log.user.last_name}` }}</span>
                  <span class="event-date">{{ log.created_at | formatDate }}</span>
                </v-flex>
                <v-flex md-12>
                  <span>{{ log.description }}</span>
                </v-flex>
              </v-flex>
              </v-flex>
              </vue-perfect-scrollbar>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </dialog-v2>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Avatar from 'vue-avatar';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import DialogV2 from '@/components/global/DialogV2';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    id: {
      required: true,
    },
  },
  components: {
    Avatar,
    DialogV2,
    VuePerfectScrollbar,
  },
  filters: {
    formatDate(logDate) {
      return moment(logDate).format('MM/DD/YYYY hh:mm A');
    },
  },
  data() {
    return {
      logs: [],
    };
  },
  computed: {
    haveData() {
      return this.logs.length > 0;
    },
  },
  methods: {
    async getLogs() {
      const data = await this.axios.get(`workflows/logs/${this.id}`).then((response) => response.data).catch(false);
      if(!data) {
        return false;
      }
      this.logs = data;
    }
  },
  watch: {
    async show() {
      if(this.show) {
        await this.getLogs();
      }
    },
  },
};
</script>

<style scoped>
.draggable-list .ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.draggable-list .handle:hover {
  cursor: pointer;
}
.input-group {
  padding-top: 0 !important;
}
.input-group >>> input {
  text-align: center !important;
}
.daily-button >>> .btn__content {
  background-color: #e0e0e0;
}
.daily-button.k-orange-linear >>> .btn__content {
  background-color: #ff7c64;
}

.log-entry {
  min-height: 66px !important;
}
.even-log {
  background-color: #F1F1F1;
  /* min-height: 200px !important; */
}
.non-log {
  background-color: #F6F6F6;
  /* min-height: 200px !important; */
}
.no-info {
  background-color: #EDEEF2;
  min-height: 200px !important;
}
.custom-avatar {
  border: 1px solid #707070;
  border-radius: 50%;
}
.event-date {
  color: #6B7170;
}
.scrollbar {
  max-height: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/LogModal.vue